import React, { useState } from "react";
import { Button } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { ModalPedidosPreparadosN2 } from "../modals";

/**
 * Botón que abre el listado de los últimos pedidos de Nave 2 ya preparados
 */
const BotonPedidosPreparadosN2 = () => {
    const [abierto, setAbierto] = useState(false);

    return (
        <>
            <Button
                variant="outlined"
                size="small"
                startIcon={<HistoryIcon />}
                onClick={() => setAbierto(true)}
                sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color: "#cc071e",
                    borderColor: "#cc071e",
                    whiteSpace: "nowrap",
                    "&:hover": { borderColor: "#a30618", backgroundColor: "#fdece9" }
                }}
            >
                Últimos preparados
            </Button>
            <ModalPedidosPreparadosN2 show={abierto} onHide={() => setAbierto(false)} />
        </>
    );
};

export default BotonPedidosPreparadosN2;
